export const creditCardLimitInfo = {
    types: ['CREDIT'],
};
